import Skeleton from "react-loading-skeleton";
import Partition from "../../../components/common/partition";
import type { ProductQuery } from "../../../__generated__/graphql";

type Product = ProductQuery["product"];

interface ProductPriceSectionProps {
  product: Product | null | undefined;
  loading: boolean;
  quantity: number;
  onIncrease: () => void;
  onDecrease: () => void;
}

const ProductPriceSection = ({
  product,
  loading,
  quantity,
  onIncrease,
  onDecrease,
}: ProductPriceSectionProps) => {
  return (
    <>
      <div className="w-full p-5 h-auto flex justify-between items-center bg-white">
        {loading ? (
          <Skeleton style={{ height: 20, width: 58 }} />
        ) : (
          <div className="text-black text-lg font-semibold">가격</div>
        )}
        <div className="flex items-center space-x-2">
          {loading ? (
            <Skeleton style={{ height: 20, width: 58 }} />
          ) : (
            <div className="text-[#dadada] text-lg line-through">
              {product?.price.toLocaleString()}원
            </div>
          )}
          {loading ? (
            <Skeleton style={{ height: 20, width: 58 }} />
          ) : (
            <div className="text-black text-lg font-bold">
              {product?.userPrice.toLocaleString()}원
            </div>
          )}
        </div>
      </div>
      <Partition color="light" height="md" />
      <div className="w-full h-auto flex items-center justify-between px-5 py-5 bg-white">
        <div className="flex items-center">
          {loading ? (
            <Skeleton style={{ height: 20, width: 58 }} />
          ) : (
            <div className="text-black text-lg font-semibold">수량</div>
          )}
        </div>
        <div className="flex items-center">
          <div
            onClick={onDecrease}
            className="w-[43px] h-[43px] flex items-center justify-center border border-[#e1e1e1] rounded-tl-[3px] rounded-bl-[3px]"
          >
            <span className="text-black text-xl">-</span>
          </div>
          <div className="w-[43px] h-[43px] flex items-center justify-center border-t border-b border-[#e1e1e1]">
            <span className="text-black text-base font-semibold">
              {quantity}
            </span>
          </div>
          <div
            onClick={onIncrease}
            className="w-[43px] h-[43px] flex items-center justify-center border border-[#e1e1e1] rounded-tr-[3px] rounded-br-[3px]"
          >
            <span className="text-black text-xl">+</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductPriceSection;
